module.exports = __webpack_public_path__ + "assets/img/avatar.5375e6e1.jpg";